import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';

import feefoServiceRatingSvg from 'src/components/molecules/TrustCarousel/feefo-service-rating-4.7.svg';
import { NOTHSLogo } from './NOTHSLogo';
import type { TrustItemProps } from './TrustItem';
import { TrustItem } from './TrustItem';
import * as styles from './TrustCarousel.styles';

interface TrustCarouselProps {
  items: TrustItemProps[];
  onItemVisible?: (visibleHeadingText: string) => void;
  onVisible?: (visibleHeadingText: string) => void;
}

export const TrustCarousel = ({ items = [], onItemVisible, onVisible }: TrustCarouselProps) => {
  const trustCarouselRef = useImpressionRef<HTMLDivElement>(() => {
    const visibleHeadingText = items.map((item) => `${item.headerText} ${item.heading}`).join(', ');

    onVisible?.(visibleHeadingText);
  });

  return (
    <div css={styles.root} ref={trustCarouselRef}>
      <h3 css={styles.heading}>
        <span>We are…</span>
        <NOTHSLogo />
      </h3>
      <div css={styles.scrollable}>
        <ul css={styles.list}>
          {items.map((item, index) => (
            <TrustItem key={index} onItemVisible={onItemVisible} {...item} />
          ))}
        </ul>
      </div>
      <div css={styles.serviceRating}>
        <h3>Our service is rated Excellent</h3>
        <a href="/reviews">
          <img alt="Feefo rating: 4.7" src={feefoServiceRatingSvg} />
        </a>
      </div>
    </div>
  );
};
